import { apiPostRaw } from "./AGIAPI";


export async function getExport(exportId, filters) {
    return await apiPostRaw(`exports/${encodeURIComponent(exportId)}`, filters);
}
